var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shortcuts-container",
      class: { "is-dark": _vm.dark },
      style: [{ height: _vm.height + "px" }]
    },
    _vm._l(_vm.shortcuts, function(shortcut) {
      return _c(
        "CustomButton",
        {
          key: shortcut.value,
          staticClass: "shortcut-button",
          attrs: {
            dark: _vm.dark,
            color: _vm.color,
            selected: shortcut.isSelected,
            "with-border": ""
          },
          on: {
            mouseover: function($event) {
              shortcut.isHover = true
            },
            mouseleave: function($event) {
              shortcut.isHover = false
            },
            click: function($event) {
              return _vm.select(shortcut)
            }
          }
        },
        [
          _c("span", { staticClass: "lm-fs-12 flex-1" }, [
            _vm._v("\n      " + _vm._s(shortcut.label) + "\n    ")
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }